if (!customElements.get('size-guide-modal')) {
  customElements.define(
    'size-guide-modal',
    class SizeGuideModal extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.hidden = true;
        this._onKey = (event) => {
          if (event.key === 'Escape') this.close();
        };

        document.querySelectorAll('[data-rsg-open="' + this.id + '"]').forEach((btn) => {
          btn.addEventListener('click', () => this.open());
        });
        this.querySelectorAll('[data-rsg-close]').forEach((btn) => {
          btn.addEventListener('click', () => this.close());
        });

        // Escape any ancestor stacking context so the overlay covers the header.
        if (this.parentElement !== document.body) document.body.appendChild(this);
      }

      open() {
        this.hidden = false;
        document.documentElement.classList.add('lock');
        document.addEventListener('keydown', this._onKey);
      }

      close() {
        this.hidden = true;
        document.documentElement.classList.remove('lock');
        document.removeEventListener('keydown', this._onKey);
      }
    }
  );
}
